import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Wrapper } from "./approvedEsign.styles";
import thumbsUp from "../animatedGifs/tracker-approved-optimised.gif";
import { PUBLIC_ROUTE } from "../../../route.constants";
import { GradientButton } from "./gradientButton";
import { formatMoney } from "../helpers";

export const ApprovedEsign = () => {
  const {
    loanType,
    loanAmount,
    loanTerm,
    repaymentAmount,
    repaymentFrequency,
    creditLimit,
    daysUntilExpiry,
  } = useSelector((state) => state.trackingStatus.value);
  const { id } = useSelector((state) => state.StartUp.queryString);
  const navigate = useNavigate();

  const onClickEsign = () => {
    navigate(PUBLIC_ROUTE.ESIGN + `?id=` + id);
  };

  const formattedRepaymentFrequency = repaymentFrequency.toLowerCase();
  const formattedLoanTerms = loanTerm.toLowerCase();

  return (
    <Wrapper>
      <img className="animated-gif-thumb" src={thumbsUp} alt="approved" />
      <h2>Congratulations!</h2>
      <p className="approved-title">Your loan application has been approved.</p>

      <div className="loan-terms">
        <div className="loan-terms-inner">
          <div className="personal-loan-info">
            {loanType !== "LOC" ? (
              <>
                <div className="loan-amount">
                  <p>Loan Amount</p>
                  <p className="loan-amount-mobile">{formatMoney(loanAmount)}</p>
                </div>
                <div className="loan-term">
                  <p>Loan Term</p>
                  <p className="loan-term-mobile">{formattedLoanTerms}</p>
                </div>
              </>
            ) : (
              <div className="credit-limit">
                <p>Credit Limit</p>
                <p className="credit-limit-mobile">{formatMoney(creditLimit)}</p>
              </div>
            )}
            <div className="repayment-amount">
              <p>Repayments</p>
              <p className="repayment-amount-mobile">
                {formatMoney(repaymentAmount)} {formattedRepaymentFrequency}
              </p>
            </div>
          </div>
          <div className="values-column">
            {loanType !== "LOC" ? (
              <div className="personal-loan-values">
                <div className="loan-amount-value">
                  <p>: {formatMoney(loanAmount)}</p>
                </div>
                <div className="loan-term-value">
                  <p>: {formattedLoanTerms}</p>
                </div>
              </div>
            ) : (
              <div className="loc-values">
                <p>: {formatMoney(creditLimit)}</p>
              </div>
            )}
            <div className="repayment-amount-value">
              <p>
                : {formatMoney(repaymentAmount)} {formattedRepaymentFrequency}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="esign-content">
        This offer will expire in <span>{daysUntilExpiry}</span>, so please
        eSign your loan contract now by clicking the eSign link below.
      </div>
      <GradientButton
        onClick={onClickEsign}
        className="esign-button"
        buttonText="Esign Your Contract"
      />
    </Wrapper>
  );
};
